// Packages
import PropTypes from 'prop-types'

// Components
import SupplierForm from 'modules/Suppliers/components/Form';

// Other
import useApi from 'hooks/useApi';

const SupplierEditScreen = ({  itemId, onClose, onSubmit }) => {

    const { data: item, put: updateItem, errors } = useApi('/suppliers/' + itemId);

	const submit = async (values) => {

        if( await updateItem(values, 'Supplier updated!')) {

            onSubmit();
        }
    }

    return(
        <SupplierForm 
            errors={errors} 
            supplier={item} 
            onClose={onClose} 
            onSubmit={submit} 
            type='edit' 
        />
    )
}

SupplierEditScreen.propTypes = {
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
    onSubmit: PropTypes.func,
}

SupplierEditScreen.defaultProps = {
    itemId: null,
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')}
}

export default SupplierEditScreen;